import React, { useEffect, useState } from "react";
import { useLocation, useNavigate,} from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BlogDetailsMain from "./BlogDetailsMain";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumbs";
import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "../home/DownloadApp";
import { SERVER_URL } from "../../api/url";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';

const BlogDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const uniqueId= uuidv4();

  // Destructure the post from location.state (if available)
  const { post } = location.state || {}; 
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // If no post is found, navigate back or show an error message


  
 const fetchBlogs = async () => {
  try {
    const response = await axios.get(`${SERVER_URL}/blog/get-single-blog`, {
      params: { 
        id: post._id 
      },
      headers: { 
        'Accept': 'application/json',
        'unique_id': uniqueId 
      },
    });
    const fetchedBlogData = response.data?.data;
    setData(fetchedBlogData || null); 

  } catch (err) {
    console.error("Error fetching blog:", err.response?.data?.error || err.message);
 
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    if (!post) {
      navigate("/blog"); 
    } else {
      fetchBlogs();
    }
  }, []);


  return (
    <body className="course-single blog-post-page blog-post-single-page">
      <Header parentMenu="blog" menuCategoryEnable="enable" />

      <div className="react-wrapper">
       {
        !loading && (
          <div className="react-wrapper-inner">
          <Breadcrumb
            postTitle={data.displayTitle}
            postImg={data.image}
            postBannerImg={data?.coverMobile}
            postCategory={data.badge}
            postAuthor={data.userName}
            postPublishedDate={post?.createdAt}
            postTotalView={data.views}
          />

          {/* Blog Main */}
          <BlogDetailsMain
            postTitle={data.title}
            postDescription={data.content}
           
            postAuthor={data.author}
           
            postPublishedDate={data.createdAt}
            postTotalView={data.views}
          />
          {/* Blog Main End */}
          <DownloadApp/>
          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
        )
       }
      </div>

      <Footer />
    </body>
  );
};

export default BlogDetails;
